// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 513) return "static/css/513.1f94a0116067c7784c23.lib.css";
	if (chunkId === 362) return "static/css/362.e0a6bd46aafedad481b0.css";
	// return url for filenames based on template
	return undefined;
};